import React, { useContext } from "react";
import "./contact.css";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import { ModeContext } from "../utils/modes-context";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_6kimd8c",
        "template_ql7mhzc",
        form.current,
        "vbCjePCf6E12Qm3kB"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
  };

  const { darkMode } = useContext(ModeContext);

  return (
    <section
      className={darkMode ? "contact" : "contact contact_lightmode"}
      id="contact">
      <h1 className="sub_heading">
        Contact me <span></span>
      </h1>
      <form className="form" onSubmit={sendEmail} ref={form}>
        <div className="field">
          <input
            type="email"
            name="email"
            id="email"
            placeholder="email"
            required
          />
          <label htmlFor="email">Email</label>
        </div>
        <div className="field">
          <input
            type="text"
            name="name"
            id="name"
            placeholder="name"
            required
          />
          <label htmlFor="name">Name</label>
        </div>
        <div className="field">
          <textarea
            name="message"
            id=""
            cols="30"
            rows="10"
            required></textarea>
        </div>
        <input type="submit" className="btn" value="Submit" />
      </form>
    </section>
  );
};

export default Contact;
